import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import TkField from '@/../bower_components/teknisavuecomponents/components/fields/TkField.vue';
import TkFile from '@/../bower_components/teknisavuecomponents/components/document/TkFile/TkFile.vue';
import TkToolbar from '@/../bower_components/teknisavuecomponents/components/grids/TkToolbar.vue';

import CommonRequests from '@/assets/ts/controller/CommonRequests';
import IndicadoresController from '@/assets/ts/controller/IndicadoresController';
import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';

import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import VueApexCharts from 'vue-apexcharts';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';

@Component({
  name: 'IndicadoresAcidentes',
  components: {
    TkFile,
    TkField,
    TkToolbar,
    apexchart: VueApexCharts,
  },
})
class IndicadoresAcidentes extends Vue {
  // #region [ STORE ]

  private get user(): User {
    return this.$store.getters.user;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  private get periodoDemonstrativoAtual(): Periodo {
    return this.$store.getters.periodoDemonstrativoAtual;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (string) => void;

  @Mutation('updateEstruturaGerencialAtual')
  private updateEstruturaGerencialAtual: (any) => void;

  private get estruturasGerenciaisStore(): Estrutura[] {
    return this.$store.getters.estruturasGerenciais;
  }

  private chart?: ApexCharts;

    //Acidentes
  private async getIndicadores() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalAcidentes(dtmesCompetenc, dp);
      const qntdAcidentes: number[] = [];
      const indicadores: string[] = [];
      
      for (const total of totais) {
        qntdAcidentes.push(parseInt(total.QTD_ACIDENTES, 10));
        indicadores.push(total.INDICADOR);
      }
  

      this.seriesPieAcidentesLegalOcup = qntdAcidentes;
      this.chartOptionsPieAcidentesLegalOcup.labels = indicadores;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.chart as any).chart) {
          this.chart = (this.$refs.chart as any).chart;

          this.chart.updateSeries(qntdAcidentes);
          this.chart.updateOptions({ labels: indicadores });
        }
       
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de Acidentes (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
  
  private async getTotalAcidentesGerenOcup() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalAcidentesGerenOcup(dtmesCompetenc, dp);

      const qntdAcidentes: number[] = [];
      const indicadores: string[] = [];
      
      for (const total of totais) {
        qntdAcidentes.push(parseInt(total.QTD_ACIDENTES, 10));
        indicadores.push(total.INDICADOR);
      }
      
      this.seriesPieAcidentesGerenOcup = qntdAcidentes;
      this.chartOptionsPieAcidentesGerenOcup.labels = indicadores;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.AcidentesGerenOcup as any).chart) {
          this.chart = (this.$refs.AcidentesGerenOcup as any).chart;

          this.chart.updateSeries(qntdAcidentes);
          this.chart.updateOptions({ labels: indicadores });
        }
        
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de Acidentes (Estrutura Gerencial x Ocupação)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
  
  private async getTotalAcidentesOcupacaoGeral() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalAcidentesOcupacaoGeral(dtmesCompetenc, dp);

      const qntdAcidentes: number[] = [];
      const indicadores: string[] = [];
      
      for (const total of totais) {
        qntdAcidentes.push(parseInt(total.QTD_ACIDENTES, 10));
        indicadores.push(total.OCUPACAO);
      }
     
      this.seriesPieAcidentesOcupacaoGeral = qntdAcidentes;
      this.chartOptionsPieAcidentesOcupacaoGeral.labels = indicadores;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.AcidentesOcupGeral as any).chart) {
          this.chart = (this.$refs.AcidentesOcupGeral as any).chart;

          this.chart.updateSeries(qntdAcidentes);
          this.chart.updateOptions({ labels: indicadores });
        }
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de Acidentes (Ocupação Geral)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  //Acidentes por Gravidade
  private async getTotalAcidentesPorGravidadeLegalOcupacao() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalAcidentesPorGravidadeLegalOcupacao(dtmesCompetenc, dp);

      const qntdAcidentes: number[] = [];
      const gravidades: string[] = [];
      
      for (const total of totais) {
        qntdAcidentes.push(parseInt(total.QTD_ACIDENTES, 10));
        gravidades.push(total.INDICADOR);
      }

      this.seriesGravidade = qntdAcidentes;
      this.chartOptionsGravidade.labels = gravidades;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.AcidentesGravLegalOcup as any).chart) {
          this.chart = (this.$refs.AcidentesGravLegalOcup as any).chart;

          this.chart.updateSeries(qntdAcidentes);
          this.chart.updateOptions({ labels: gravidades });
        }
        
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de Acidentes Por Gravidade (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private async getTotalAcidentesPorGravidadeGerenOcup() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalAcidentesPorGravidadeGerenOcup(dtmesCompetenc, dp);
      
      const qntdAcidentes: number[] = [];
      const gravidades: string[] = [];
      
      for (const total of totais) {
        qntdAcidentes.push(parseInt(total.QTD_ACIDENTES, 10));
        gravidades.push(total.INDICADOR);
      }

      this.seriesGravidadeGerenOcup = qntdAcidentes;
      this.chartOptionsGravidadeGerenOcup.labels = gravidades;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.AcidentesGravGerenOcup as any).chart) {
          this.chart = (this.$refs.AcidentesGravGerenOcup as any).chart;

          this.chart.updateSeries(qntdAcidentes);
          this.chart.updateOptions({ labels: gravidades });
        }
        
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de Acidentes Por Gravidade (Estrutura Gerencial x Ocupação)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private async getTotalAcidentesPorGravidadeOcupacaoGeral() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalAcidentesPorGravidadeOcupacaoGeral(dtmesCompetenc, dp);
      
      const qntdAcidentes: number[] = [];
      const gravidades: string[] = [];
      
      for (const total of totais) {
        qntdAcidentes.push(parseInt(total.QTD_ACIDENTES, 10));
        gravidades.push(total.OCUPACAO);
      }

      this.seriesGravidadeOcupacaoGeral = qntdAcidentes;
      this.chartOptionsGravidadeOcupacaoGeral.labels = gravidades;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.AcidentesGravOcupGeral as any).chart) {
          this.chart = (this.$refs.AcidentesGravOcupGeral as any).chart;

        this.chart.updateSeries(qntdAcidentes);
        this.chart.updateOptions({ labels: gravidades });
        }
        
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de Acidentes Por Gravidade (Ocupação Geral)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

    //Partes do corpo
  private async getTotalPartesDoCorpoAtingidasLegalOcup() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalPartesDoCorpoAtingidasLegalOcup(dtmesCompetenc,dp);
      
      const qntdAcidentes: number[] = [];
      const indicadores: string[] = [];
      
      for (const total of totais) {
        qntdAcidentes.push(parseInt(total.QTD_ACIDENTES, 10));
        indicadores.push(total.INDICADOR);
      }

      this.seriesPartesDoCorpoAtingidasLegalOcup = qntdAcidentes;
      this.chartOptionsPartesDoCorpoAtingidasLegalOcup.labels = indicadores;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.PartesAtingidasLegalOcup as any).chart) {
          this.chart = (this.$refs.PartesAtingidasLegalOcup as any).chart;

          this.chart.updateSeries(qntdAcidentes);
          this.chart.updateOptions({ labels: indicadores });
        }
        
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de Partes do Corpo Atingidas (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private async getTotalPartesDoCorpoAtingidasOcupacaoGeral() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalPartesDoCorpoAtingidasOcupacaoGeral(dtmesCompetenc, dp);
      
      const qntdAcidentes: number[] = [];
      const indicadores: string[] = [];
      
      for (const total of totais) {
        qntdAcidentes.push(parseInt(total.QTD_ACIDENTES, 10));
        indicadores.push(total.INDICADOR);
      }
      this.seriesPartesDoCorpoAtingidasOcupacaoGeral = qntdAcidentes;
      this.chartOptionsPartesDoCorpoAtingidasOcupacaoGeral.labels = indicadores;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.PartesAtingidasOcupacaoGeral as any).chart) {
          this.chart = (this.$refs.PartesAtingidasOcupacaoGeral as any).chart;

          this.chart.updateSeries(qntdAcidentes);
          this.chart.updateOptions({ labels: indicadores });
        }
      }); 
    } catch (err) {
      const message = 'Não foi possível carregar o total de Partes do Corpo Atingidas (Ocupação Geral)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  //Dias Afastasdos
  private async getQuantidadeDiasAfastadosLegalOcup() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getQuantidadeDiasAfastadosLegalOcup(dtmesCompetenc, dp);
  
      const diasAfastados: number[] = totais.map(item => item.QTD_AFASTAMENTOS);
      const categorias: string[]= totais.map(item => item.INDICADOR);

      this.seriesBarLegalOcup = [{ data: diasAfastados }];
      this.chartOptionsBarDiasAfastadosLegalOcup.xaxis.categories = categorias;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.DiasAfastadosLegalOcup as any).chart) {
          this.chart = (this.$refs.DiasAfastadosLegalOcup as any).chart;

          this.chart.updateSeries(diasAfastados);
          this.chart.updateOptions({
            xaxis: {
              categories: categorias
            }
          });
        }
       
      }); 

    } catch (err) {
      const message = 'Não foi possível carregar a Quantidade de dias afastados (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
  
  private async getQuantidadeDiasAfastadosOcupacaoGeral() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getQuantidadeDiasAfastadosOcupacaoGeral(dtmesCompetenc, dp);

      const diasAfastados: number[] = totais.map(item => item.QTD_AFASTAMENTOS);
      const categorias: string[]= totais.map(item => item.INDICADOR);

      this.seriesBarOcupGeral = [{ data: diasAfastados }];
      this.chartOptionsBarOcupGeral.xaxis.categories = categorias;


      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.DiasAfastadosOcupGeral as any).chart) {
          this.chart = (this.$refs.DiasAfastadosOcupGeral as any).chart;

          this.chart.updateSeries(diasAfastados);
          this.chart.updateOptions({
            xaxis: {
              categories: categorias
            }
          });
        }     
      }); 
    } catch (err) {
      const message = 'Não foi possível carregar a Quantidade de dias afastados (Ocupação Geral)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  // Situação Geradora
  private async getSituacaoGeradoraAcidenteLegalOcup() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getSituacaoGeradoraAcidenteLegalOcup(dtmesCompetenc, dp);

      const qntdAcidentes: number[] = totais.map(item => item.QTD_ACIDENTES);
      const situacao: string[] = totais.map(item => item.INDICADOR);

      this.seriesBarSituacaoGeradora = [{ data: qntdAcidentes }];
      this.chartOptionsBarSituacaoGeradora.xaxis.categories = situacao;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.SituacaoGeradoraLegalOcup as any).chart) {
          this.chart = (this.$refs.SituacaoGeradoraLegalOcup as any).chart;

          this.chart.updateSeries(qntdAcidentes);
          this.chart.updateOptions({
            xaxis: {
              categories: situacao
            }
          });
        }
        
      }); 
    } catch (err) {
      const message = 'Não foi possível carregar a Situação Geradora Acidente (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private async getSituacaoGeradoraAcidenteOcupacaoGeral() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getSituacaoGeradoraAcidenteOcupacaoGeral(dtmesCompetenc, dp);

      const qntdAcidentes: number[] = totais.map(item => item.QTD_ACIDENTES);
      const situacao: string[] = totais.map(item => item.INDICADOR);

      this.seriesBarSituacaoGeradoraOcupacaoGeral = [{ data: qntdAcidentes }];
      this.chartOptionsBarSituacaoGeradoraOcupacaoGeral.xaxis.categories = situacao;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.SituacaoGeradoraOcupGeral as any).chart) {
          this.chart = (this.$refs.SituacaoGeradoraOcupGeral as any).chart;

          this.chart.updateSeries(qntdAcidentes);
          this.chart.updateOptions({
            xaxis: {
              categories: situacao
            }
          });
        }
       
      }); 
    } catch (err) {
      const message = 'Não foi possível carregar a Situação Geradora Acidente (Ocupação Geral)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
  
  // #endregion

  // #region [ DATA ]
  private readonly viewTitle = 'Indicadores de Acidentes';

  
  // Graficos 
  private seriesPieAcidentesLegalOcup: number[] = [];
  private chartOptionsPieAcidentesLegalOcup = {
    labels: [] as string[],
    title: {
      text: 'Total de Acidentes (Estrutura Legal x Ocupação) ',
    },
    chart: {
      type: 'donut',
      width: 50,
      height: 50,
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_acidentes_legal_ocupacao',
          },
          svg: {
            filename: 'total_acidentes_legal_ocupacao',
          },
          png: {
            filename: 'total_acidentes_legal_ocupacao',
          }
        }
      }
    },
  };
  
  private seriesPieAcidentesGerenOcup: number[] = [];
  private chartOptionsPieAcidentesGerenOcup = {
    labels: [] as string[],
    title: {
      text: 'Total de Acidentes (Estrutura Gerencial x Ocupação) ',
    },
    chart: {
      type: 'donut',
      width: 50,
      height: 50,
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_acidentes_gerencial_ocupacao',
          },
          svg: {
            filename: 'total_acidentes_gerencial_ocupacao',
          },
          png: {
            filename: 'total_acidentes_gerencial_ocupacao',
          }
        }
      }
    },
  };

  private seriesPieAcidentesOcupacaoGeral: number[] = [];
  private chartOptionsPieAcidentesOcupacaoGeral = {
    labels: [] as string[],
    title: {
      text: 'Total de Acidentes (Ocupação Geral)',
    },
    chart: {
      type: 'donut',
      width: 50,
      height: 50,
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_acidentes_ocupacao_geral',
          },
          svg: {
            filename: 'total_acidentes_ocupacao_geral',
          },
          png: {
            filename: 'total_acidentes_ocupacao_geral',
          }
        }
      }
    },
  };

  private seriesGravidade: number[] = [];
  private chartOptionsGravidade = {
    chart: {
      type: 'polarArea',
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_acidentes_gravidade_legal_ocupacao',
          },
          svg: {
            filename: 'total_acidentes_gravidade_legal_ocupacao',
          },
          png: {
            filename: 'total_acidentes_gravidade_legal_ocupacao',
          }
        }
      }
    },
    title: {
      text: 'Total de Acidentes Por Gravidade (Estrutura Legal x Ocupação)',
    },
    labels: [] as string[],
    stroke: {
      colors: ['#fff'],
    },
    fill: {
      opacity: 0.8,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  private seriesGravidadeGerenOcup: number[] = [];
  private chartOptionsGravidadeGerenOcup = {
    chart: {
      type: 'polarArea',
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_acidentes_gravidade_gerencial_ocupacao',
          },
          svg: {
            filename: 'total_acidentes_gravidade_gerencial_ocupacao',
          },
          png: {
            filename: 'total_acidentes_gravidade_gerencial_ocupacao',
          }
        }
      }
    },
    title: {
      text: 'Total de Acidentes Por Gravidade (Estrutura Gerencial x Ocupação)',
    },
    labels: [] as string[],
    stroke: {
      colors: ['#fff'],
    },
    fill: {
      opacity: 0.8,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  private seriesGravidadeOcupacaoGeral: number[] = [];
  private chartOptionsGravidadeOcupacaoGeral = {
    chart: {
      type: 'polarArea',
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_acidentes_gravidade_ocupacao_geral',
          },
          svg: {
            filename: 'total_acidentes_gravidade_ocupacao_geral',
          },
          png: {
            filename: 'total_acidentes_gravidade_ocupacao_geral',
          }
        }
      }
    },
    title: {
      text: 'Total de Acidentes Por Gravidade (Ocupação Geral)',
    },
    labels: [] as string[],
    stroke: {
      colors: ['#fff'],
    },
    fill: {
      opacity: 0.8,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  private seriesPartesDoCorpoAtingidasLegalOcup: number[] = [];
  private chartOptionsPartesDoCorpoAtingidasLegalOcup = {
    labels: [] as string[],
    title: {
      text: 'Total de Partes Do Corpo Atingidas (Estrutura Legal x Ocupação) ',
    },
    chart: {
      type: 'pie',
      width: 50,
      height: 50,
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_partes_atingidas_legal_ocupacao',
          },
          svg: {
            filename: 'total_partes_atingidas_legal_ocupacao',
          },
          png: {
            filename: 'total_partes_atingidas_legal_ocupacao',
          }
        }
      }
    },
  };

  private seriesPartesDoCorpoAtingidasOcupacaoGeral: number[] = [];
  private chartOptionsPartesDoCorpoAtingidasOcupacaoGeral = {
    labels: [] as string[],
    title: {
      text: 'Total de Partes Do Corpo Atingidas (Ocupação Geral)',
    },
    chart: {
      type: 'pie',
      width: 50,
      height: 50,
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_partes_atingidas_ocupacao_geral',
          },
          svg: {
            filename: 'total_partes_atingidas_ocupacao_geral',
          },
          png: {
            filename: 'total_partes_atingidas_ocupacao_geral',
          }
        }
      }
    },
  };

  private seriesBarOcupGeral = [{ data: [] as number[] }];


  private chartOptionsBarOcupGeral = {
    chart: {
      type: 'bar',
      height: 380,
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'dias_afastados_ocupacao_geral',
          },
          svg: {
            filename: 'dias_afastados_ocupacao_geral',
          },
          png: {
            filename: 'dias_afastados_ocupacao_geral',
          }
        }
      }
  },
  title: {
    text: 'Quantidade de dias afastados (Ocupação Geral)',
  },
  plotOptions: {
      bar: {
          horizontal: true,
          distributed: true,
          dataLabels: {
              position: 'top',
              enabled: true,
              style: {
                  colors: ['#'] 
              },
              formatter: function (val, opt) {
                  return val;
              },
              offsetX: 20,
              dropShadow: {
                  enabled: true
              }
          },
      }
  },
  colors: ['#1E90FF', '#00BFFF', '#4682B4', '#5F9EA0', '#6495ED', '#87CEEB', '#4169E1', '#0000FF'],
  dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: {
        fontSize: '14px', 
        fontWeight: 'bold',
        colors: ['#000'] 
    },
    formatter: function (val, opt) {
        return val;
    },
    offsetX: 20,
      dropShadow: {
          enabled: true
      }
  },
  stroke: {
      width: 1,
      colors: ['#fff']
  },
  xaxis: {
      categories: [],
      labels: {
        show: false,
          style: {
              fontSize: '15px'
          }
      }
  },
  yaxis: {
  },
  legend: {
    position: 'top'
},
  tooltip: {
      theme: 'dark',
      y: {
          title: {
              formatter: function () {
                  return '';
              }
          }
      }
  }
};
  

  private seriesBarLegalOcup = [{ data: [] as number[] }];

  private chartOptionsBarDiasAfastadosLegalOcup = {
    chart: {
      type: 'bar',
      height: 380,
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'dias_afastados_legal_ocupacao',
          },
          svg: {
            filename: 'dias_afastados_legal_ocupacao',
          },
          png: {
            filename: 'dias_afastados_legal_ocupacao',
          }
        }
      }
  },
  title: {
    text: 'Quantidade de dias afastados (Estrutura Legal x Ocupação)',
  },
  plotOptions: {
      bar: {
          horizontal: true,
          distributed: true,
          dataLabels: {
              position: 'top',
              enabled: true,
              style: {
                  colors: ['#'] 
              },
              formatter: function (val, opt) {
                  return val;
              },
              offsetX: 20,
              dropShadow: {
                  enabled: true
              }
          },
      }
  },
  colors: ['#1E90FF', '#00BFFF', '#4682B4', '#5F9EA0', '#6495ED', '#87CEEB', '#4169E1', '#0000FF'],
  dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: {
        fontSize: '14px', 
        fontWeight: 'bold',
        colors: ['#000'] 
      },
      formatter: function (val, opt) {
          return val;
      },
      offsetX: 20,
      dropShadow: {
          enabled: true
      }
  },
  stroke: {
      width: 1,
      colors: ['#fff']
  },
  xaxis: {
      categories: [],
      labels: {
        show: false,
          style: {
              fontSize: '15px'
          }
      }
  },
  legend: {
    position: 'top'
},
  tooltip: {
      theme: 'dark',
      y: {
          title: {
              formatter: function () {
                  return '';
              }
          }
      }
  }
  };

  private seriesBarSituacaoGeradora = [{
    data: [] as number[]
  }];


  private chartOptionsBarSituacaoGeradora = {
      chart: {
        type: 'bar',
        height: 380,
        toolbar: {
          show: true,
          tools: {
            download: true
          },
          export: {
            csv: {
              filename: 'situacao_geradora_acidente_legal_ocupacao',
            },
            svg: {
              filename: 'situacao_geradora_acidente_legal_ocupacao',
            },
            png: {
              filename: 'situacao_geradora_acidente_legal_ocupacao',
            }
          }
        }
    },
    title: {
      text: 'Situação Geradora Acidente (Estrutura Legal x Ocupação)',
    },
    plotOptions: {
        bar: {
            horizontal: false,
            distributed: true,
            dataLabels: {
                position: 'top',
                enabled: true,
                style: {
                    colors: ['#'] 
                },
                formatter: function (val, opt) {
                    return val;
                },
                offsetY: -20,
                dropShadow: {
                    enabled: true
                }
            },
        }
    },
    colors: ['#1E90FF', '#87CEEB','#4682B4', '#5F9EA0', '#6495ED',   '#00BFFF', '#4169E1', '#0000FF'],
    dataLabels: {
        enabled: true,
        textAnchor: 'middle',
        style: {
            colors: ['#']
        },
        formatter: function (val, opt) {
            return val;
        },
        offsetY: -20,
        dropShadow: {
            enabled: true
        }
    },
    stroke: {
        width: 1,
        colors: ['#fff']
    },
    xaxis: {
        categories: [],
        labels: {
          show: false,
            style: {
                fontSize: '15px'
            }
        }
    },
    yaxis: {
        title: {
            text: 'Valores'
        },
    },
    legend: {
      position: 'top'
  },
    tooltip: {
        theme: 'dark',
        y: {
            title: {
                formatter: function () {
                    return '';
                }
            }
        }
    }
  };

  private seriesBarSituacaoGeradoraOcupacaoGeral = [{
    data: [] as number[]
  }];


  private chartOptionsBarSituacaoGeradoraOcupacaoGeral = {
      chart: {
        type: 'bar',
        height: 380,
        toolbar: {
          show: true,
          tools: {
            download: true
          },
          export: {
            csv: {
              filename: 'situacao_geradora_acidente_ocupacao_geral',
            },
            svg: {
              filename: 'situacao_geradora_acidente_ocupacao_geral',
            },
            png: {
              filename: 'situacao_geradora_acidente_ocupacao_geral',
            }
          }
        }
    },
    title: {
      text: 'Situação Geradora Acidente (Ocupação Geral)',
    },
    plotOptions: {
        bar: {
            horizontal: false,
            distributed: true,
            dataLabels: {
                position: 'top',
                enabled: true,
                style: {
                    colors: ['#'] 
                },
                formatter: function (val, opt) {
                    return val;
                },
                offsetY: -20,
                dropShadow: {
                    enabled: true
                }
            },
        }
    },
    colors: ['#1E90FF', '#87CEEB','#4682B4', '#5F9EA0', '#6495ED',   '#00BFFF', '#4169E1', '#0000FF'],
    dataLabels: {
        enabled: true,
        textAnchor: 'middle',
        style: {
            colors: ['#']
        },
        formatter: function (val, opt) {
            return val;
        },
        offsetY: -20,
        dropShadow: {
            enabled: true
        }
    },
    stroke: {
        width: 1,
        colors: ['#fff']
    },
    xaxis: {
        categories: [],
        labels: {
          show: false,
            style: {
                fontSize: '15px'
            }
        }
    },
    yaxis: {
        title: {
            text: 'Valores'
        },
    },
    legend: {
      position: 'top'
  },
    tooltip: {
        theme: 'dark',
        y: {
            title: {
                formatter: function () {
                    return '';
                }
            }
        }
    }
  };


  private loading = false;

  private estruturasGerenciais: any[] = [];
  private estruturasLegais: any[] = [];
  private nrEstrutLegal = '';
  private nrEstrutGeren = '';
  // #endregion

  // #region [ COMPUTED ]
  private get estruturaGerencialField(): Field {
    const descField = 'NMESTRUTURA';
    const field = {
      name: 'NRESTRUTGEREN',
      valueField: 'NRESTRUTURAM',
      descriptionField: descField,
      label: 'Estrutura Gerencial',
      type: 'autocomplete',
      size: 6,
      items: this.estruturasGerenciais,
    };

    return field;
  }

  private get estruturaLegalField(): Field {
    const field: Field = {
      name: 'NRESTRUTLEGAL',
      valueField: 'NRESTRUTURAM',
      descriptionField: 'NRNMESTRUTURA',
      label: 'Estrutura Legal',
      type: 'autocomplete',
      size: 6,
      items: this.estruturasLegais,
    };

    return field;
  }

  private get toolbarActions(): ToolbarAction[] {
    const actions = [
      {
        name: 'reload',
        label: 'Atualizar',
        icon: 'mdi-refresh',
        onClick: this.reload,
        disabled: this.loading,
      },
    ];

    return actions;
  }

  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.viewTitle);
    (window as any).documentos = this;

    this.getIndicadores();
    this.getTotalAcidentesGerenOcup();
    this.getTotalAcidentesOcupacaoGeral();
    this.getTotalAcidentesPorGravidadeLegalOcupacao();
    this.getTotalAcidentesPorGravidadeGerenOcup();
    this.getTotalAcidentesPorGravidadeOcupacaoGeral();
    this.getQuantidadeDiasAfastadosLegalOcup();
    this.getQuantidadeDiasAfastadosOcupacaoGeral();
    this.getTotalPartesDoCorpoAtingidasLegalOcup();
    this.getTotalPartesDoCorpoAtingidasOcupacaoGeral();
    this.getSituacaoGeradoraAcidenteLegalOcup();
    this.getSituacaoGeradoraAcidenteOcupacaoGeral();
  }

  private mounted() {
    this.loadEstruturasGerenciais();
    this.loadEstruturasLegais();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('estruturaGerencialAtual')
  private estruturaGerencialAtualOnChange() {
    this.reload();
  }

  @Watch('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtualOnChange() {
    this.reload();
  }
  // #endregion

  // #region [ METHODS ]
  private async reload() {
    if (!this.periodoDemonstrativoAtual || !this.estruturaGerencialAtual) {
      return;
    }

    this.loading = true;

    try {
      await Promise.all([
          this.getIndicadores(),
          this.getTotalAcidentesGerenOcup(),
          this.getTotalAcidentesOcupacaoGeral(),
          this.getTotalAcidentesPorGravidadeLegalOcupacao(),
          this.getTotalAcidentesPorGravidadeGerenOcup(),
          this.getTotalAcidentesPorGravidadeOcupacaoGeral(),
          this.getQuantidadeDiasAfastadosLegalOcup(),
          this.getQuantidadeDiasAfastadosOcupacaoGeral(),
          this.getTotalPartesDoCorpoAtingidasLegalOcup(),
          this.getTotalPartesDoCorpoAtingidasOcupacaoGeral(),
          this.getSituacaoGeradoraAcidenteLegalOcup(),
          this.getSituacaoGeradoraAcidenteOcupacaoGeral()
      ]);
    } finally {
      this.loading = false;
    }
  }

  private async loadEstruturasGerenciais() {
    let estruturas = [];

    if (this.user.dp) {
      try {
        estruturas = await NovaSolicitacaoController.getEstruturas('GERENCIAL');
      } catch {
        const message = 'Não foi possível carregar as estruturas gerenciais!';
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      }
    } else {
      estruturas = this.estruturasGerenciaisStore.filter((estrutura) => {
        const isGerencial = estrutura.IDTIPOESTRUTURA === 'GERENCIAL';
        return isGerencial;
      });
    }

    this.estruturasGerenciais = estruturas;
  }

  private async loadEstruturasLegais() {
    try {
      const estruturas = await NovaSolicitacaoController.getEstruturas('LEGAL');
      this.estruturasLegais = estruturas;
    } catch (err) {
      const message = 'Não foi possível carregar as estruturas legais!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
  // #endregion
}

export default IndicadoresAcidentes;